import { useProtectedAPI } from "./apiService";
import useSWR from "swr";

import qs from "qs";

export const useGetForum = () => {
    const protectedAPI = useProtectedAPI()

    const getForum = async (forum_id) => {
        const url = `/forums/${forum_id}`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return getForum
}



export const useGetForums = () => {
    const protectedAPI = useProtectedAPI()

    const getForums = async (filters) => {
        const params = qs.stringify(filters, { arrayFormat: "repeat", skipNulls: true })
        const url = `/forums/?${params}`
        const response = await protectedAPI.get(url)
        return response.data
    }
    
    return getForums
}



export const useGetForumTopicsSWR = (id) => {
    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR(id ? `/forums/${id}/topics` : null, fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}

/* Admin */


export const useAdminGetForumsSWR= () => {

    const protectedApi = useProtectedAPI();
    const fetcher = (url) => protectedApi.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR("/admin/forums", fetcher);

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useAdminGetForums= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetForums = (filters) => {
        const queryString = qs.stringify(Object.fromEntries(Object.entries(filters).filter(([k, v]) => v)), { arrayFormat: "repeat", skipNulls: true, skipBlanks: true })
        const url = `/admin/forums?${queryString}`
        const promise = protectedAPI.get(url).then(response => {
            return {
                data: response.data,
                total: response.headers["x-total-count"]
            }
        })

        return {
            then: (resolve, reject) =>
                promise.then(result => resolve(result.data), reject),
            catch: (reject) =>
                promise.catch(reject),
            withTotal: () =>
                promise.then(result => [result.data, result.total])
        }

    }

    return adminGetForums
}



export const useAdminGetForum= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetForum = async (id) => {
        const response = await protectedAPI.get(`/admin/forums/${id}`)
        return response.data
    }

    return adminGetForum
}



export const useAdminCreateForum= () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateForum = async (data) => {
        const response = await protectedAPI.post(`/admin/forums`, data)
        return response.data
    };

    return adminCreateForum;
}



export const useAdminUpdateForum= () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateForum = async (id, data) => {
        const response = await protectedAPI.put(`/admin/forums/${id}`, data)
        return response.data
    };

    return adminUpdateForum;
}



export const useAdminDeleteForum= () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteForum = async (id) => {
        const response = await protectedAPI.delete(`/admin/forums/${id}`)
        return response.data
    };

    return adminDeleteForum;
}



export const useAdminGetForumRights= () => {
    const protectedAPI = useProtectedAPI()

    const adminGetForumRights = async (id) => {
        const response = await protectedAPI.get(`/admin/forums/${id}/rights`)
        return response.data
    }
    
    return adminGetForumRights
}



export const useAdminUpdateForumRights= () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateForumRights = async (id, data) => {
        const response = await protectedAPI.put(`/admin/forums/${id}/rights`, data)
        return response.data
    };

    return adminUpdateForumRights;
}
